<template>
  <layout name="LayoutDefault">
    <div class="Contact">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row">
            <div class="contact-form col-lg-6">

              <form id="contact" action="#" method="post" @submit="checkForm">

                <div v-if="errors.length" class="alert alert-warning">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
                  </ul>
                </div>

                <div v-if="serverMessage" class="alert alert-success">
                  {{ serverMessage }}
                </div>

                <div class="form-group">
                  <label>নতুন পাসওয়ার্ড<span class="required">*</span></label>
                  <input type="password" ref="new_password" v-model="formData.new_password" class="form-control" />
                </div>

                <div class="form-group">
                  <label>কনফার্ম পাসওয়ার্ড <span class="required">*</span></label>
                  <input type="password" ref="confirm_password" v-model="formData.confirm_password" class="form-control" />
                </div>

                <button type="submit" class="btn btn-primary">
                  রিসেট করুন <i class="fa fa-chevron-right"></i>
                </button>

                <div class="mt-2">
                  <router-link :to="{ name: 'login' }">লগইন করুন</router-link>
                </div>
                <div>
                  <router-link :to="{ name: 'signup' }">অ্যাকাউন্ট নেই? এখনই সাইন আপ করুন!</router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import $ from "jquery";

export default {
  name: `login`,
  components: {
    Layout
  },
  data() {
    return {
      errors: [],
      serverMessage: false,
      formData: {}
    };
  },
  methods: {
    async checkForm(e) {
      e.preventDefault();
      const newPassword = this.formData.new_password;
      const confirmPassword = this.formData.confirm_password;

      if (!newPassword || newPassword.length < 6) {
        this.$refs.new_password.focus();
        this.flashMessage.error({ message: "New password required and must be minimum 6 characters" });
        return false;
      }
      if (!confirmPassword) {
        this.$refs.confirm_password.focus();
        this.flashMessage.error({ message: "Confirm password required" });
        return false;
      }
      if (newPassword !== confirmPassword) {
        this.$refs.confirm_password.focus();
        this.flashMessage.error({ message: "Passwords do not match." });
        return false;
      }

      const formData = new FormData();
      formData.append(`phone`, localStorage.getItem('forgotMobile'));
      formData.append(`otp`, localStorage.getItem('otpNumber'));
      formData.append(`new_password`, newPassword);
      formData.append(`confirm_password`, confirmPassword);
      const response = await fetch(`${this.APIURL}customer/forgot-password/reset-password`, {
        method: `POST`,
        body: formData,
      });
      const verifyOtpResponse = await response.json();

      if (verifyOtpResponse.status) {
          this.flashMessage.success({ message: verifyOtpResponse.message });
          localStorage.removeItem('otpNumber');
          localStorage.removeItem('forgotMobile');
          this.$router.push('login')
      };
      this.serverMessage = verifyOtpResponse.message;
    },
  },
};
</script>
